// extracted by mini-css-extract-plugin
module.exports = {"subscribe-banner-wrapper":"styles-m__subscribe-banner-wrapper__3oyHN","subscribe-banner-link":"styles-m__subscribe-banner-link__q6lyI"};